module.exports = __webpack_public_path__ + "static/img/jiqi.1a432e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi.png
// module id = iI1f
// module chunks = 0